import React, { Component } from 'react';
import { DebugAlert, Class, Interface, Abstract, ObjectTypes, JSTypeOperator } from "../../../GenericCoreGraph/ClassFramework/Class"
import TObject from "../../../TagComponents/TObject"
import { CommandInterfaces } from "../../../GenericWebController/CommandInterpreter/cCommandInterpreter"
import Actions from "../../../GenericWebController/ActionGraph/Actions"
import GenericWebGraph from "../../../GenericWebController/GenericWebGraph"
import { CommandIDs } from "../../../GenericWebController/CommandInterpreter/CommandIDs/CommandIDs"
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import ClearIcon from '@material-ui/icons/Clear';
import { IconButton } from "@material-ui/core";

var TAvatar = Class(TObject,
  {
    ObjectType: ObjectTypes.Get("TAvatar")
    ,
    constructor: function (_Props)
    {
      TAvatar.BaseObject.constructor.call(this, _Props);
      this.state =
      {
        ...this.state,
        loading: true,
        disabled: false
      }
      this.previewImageRef = React.createRef();
      this.NeedRefresh = true;
      var __This = this;
      if (this.props.size)
      {
        this.Size = this.props.size;
        this.HalfSize = this.props.size / 2;
      }
      else
      {
        this.Size = 100;
        this.HalfSize = 50;
      }
      this.MainContainer = React.createRef();
      /*this.PeriodicControlHandle = setTimeout(function ()
      {
        //__This.HandlePeriodicControl();
      }, 100);*/
    }
    /*,
    HandlePeriodicControl: function ()
    {
      var __This = this;
      if (this.previewImageRef.current == null || !this.previewImageRef.current.complete)
      {
        this.PeriodicControlHandle = setTimeout(function ()
        {
          __This.HandlePeriodicControl();
        }, 100);
      }
      else
      {
        this.HandleRefreshable();
        this.setState({
          loading: false
        });
      }
    }*/
    ,
    Destroy: function ()
    {
      TAvatar.BaseObject.Destroy.call(this);
    }
    ,
    HandleSetImage: function (_Source)
    {
      this.previewImageRef.current.src = _Source;
    }
    ,
    HandleToDataURL: function ()
    {
      this.previewImageRef.current.toDataURL();
    }
    ,
    HandleGetComplete: function ()
    {
      this.previewImageRef.current.complete;
    }
    ,
    shouldComponentUpdate(nextProps, nextState)
    {
      if (this.NeedRefresh || this.props.src != nextProps.src)
      {
        this.state.loading = true;
        return true;
      }
      return false;
    }
    ,
    HandleRefreshable()
    {
      this.NeedRefresh = true;
    }
    ,
    componentDidMount: function ()
    {
      TAvatar.BaseObject.componentDidMount.call(this);
    }
    ,
    render()
    {
      if (!JSTypeOperator.IsDefined(this.props.needRefresh))
      {
        this.NeedRefresh = false;
      }
      var __This = this;


      return (<div ref={this.MainContainer} style={{ height: this.Size, width: this.Size }} className={this.props.className}>
          <div style={{ height: this.Size, width: this.Size}}>
            <div style={{ height: this.Size, width: this.Size }}>
            <img

                onLoad={() =>
                {
                  __This.HandleRefreshable();
                  __This.setState({
                    loading: false
                  });
                  //console.log(window.getStylePixel(this.MainContainer.current).marginLeft);
                }}

                onError={() => {
                  __This.HandleRefreshable();
                  __This.setState({
                    loading: false
                  });
                }}

              style={{ height: this.Size, width: this.Size, borderRadius: this.props.radius ? this.props.radius : this.HalfSize }}
              ref={this.previewImageRef}
              src={this.props.src}
              alt={this.props.alt}
              loading="lazy"

            />
            </div>

            {this.state.loading &&
            <div style={{ height: this.HalfSize, width: this.HalfSize, marginTop: (-this.HalfSize + -20), marginLeft: (this.HalfSize - 20)}}>
              <CircularProgress />
            </div>
            }

            {!this.state.loading && <div style={{ marginLeft: this.HalfSize, marginTop: -this.Size, height: this.HalfSize, width: this.HalfSize, zIndex: 9999, backgroundColor: JSTypeOperator.IsFunction(__This.props.onDelete) ? "rgb(0, 0, 0, 0.4)" : "rgb(0, 0, 0, 0.0)", borderRadius: (this.HalfSize / 2), position: "relative" }}>
              {JSTypeOperator.IsFunction(__This.props.onDelete) &&
              <IconButton style={{ flex: 1 }} aria-label="delete" onClick={() =>
              {
                if (JSTypeOperator.IsFunction(__This.props.onDelete))
                {
                  __This.props.onDelete();
                }
              }}>
                <ClearIcon style={{ color: "rgb(255, 255, 255, 1)" }} />
              </IconButton>}
            </div>
            }

          </div>
        </div>
      );
    }
  }, {});

export default TAvatar

